import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import styled from '@emotion/styled';


export const PopupTitle = styled(DialogTitle)(({ theme }) => `
text-align: center;
font-size: 16px;
padding: 10px 16px;
@media (min-width: 600px){
     font-size: 18px;
     padding: 16px 24px;
  }
`);

export const DialogContentStyled = styled(DialogContent)(() => `
padding: 10px 16px;
@media (min-width: 600px){
    padding: 16px 24px;
  }
`);

export const DescriptionStyled = styled.p`
max-width: 300px;
font-size: 14px;
text-align: center;
@media (min-width: 600px){
     font-size: 16px;
}
`;

export const WrapperActions = styled(DialogActions)`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 20px;
min-width: 100%;
padding: 10px 16px;
@media (min-width: 600px){
    padding: 16px 24px;
  }
`;

export const ButtonStyled = styled(Button)(({ theme, color }) => `
width: 100%;
&:not(:first-of-type) {
    margin-left: 0;
}
`);



